import { MatchElementsCardProps } from '@sport1/types/web'
import React, { FC } from 'react'
import NonFlexingContainer from '@sport1/news-styleguide/NonFlexingContainer'
import { WidgetTrackingIdentifier } from '@sport1/bets-service-client'
import CardHeadline from '@sport1/news-styleguide/CardHeadline'
import { MatchOverlayProvider } from '@/utils/overlay/MatchOverlayProvider'
import MatchCardItem from '@/components/MatchElementsCard/util'
import OddsDisclaimer from '@/components/OddsDisclaimer'

type Props = Omit<MatchElementsCardProps, 'type' | 'isHorizontal'> & {
    trackingInteractionLabel: string
    trackingCreation?: WidgetTrackingIdentifier
}

const VerticalMatchElementsCards: FC<Props> = ({
    trackingInteractionLabel,
    trackingCreation,
    headline,
    content,
}) => {
    return (
        <NonFlexingContainer
            marginBottom="spacing-9"
            marginX={['spacing-7', 'spacing-7', 'spacing-9', 'spacing-none']}
        >
            <MatchOverlayProvider top={46}>
                <>
                    <NonFlexingContainer paddingBottom="spacing-7">
                        <CardHeadline
                            text={headline}
                            cardHeadlineType={['cardHeadlineS', 'cardHeadlineM', 'cardHeadlineS']}
                        />
                    </NonFlexingContainer>
                    <NonFlexingContainer position="relative">
                        {content.map(
                            ({ matchClientModel, headline: matchHeadline, tags }, index) => {
                                const tag = tags?.length ? tags[0] : undefined
                                return (
                                    <MatchCardItem
                                        key={matchClientModel.id}
                                        match={matchClientModel}
                                        tag={tag}
                                        headline={matchHeadline}
                                        props={{
                                            spaceBottom:
                                                index < content.length - 1 ? 'small' : undefined,
                                            trackingInteractionLabel,
                                            trackingCreation,
                                        }}
                                    />
                                )
                            }
                        )}
                    </NonFlexingContainer>
                </>
            </MatchOverlayProvider>
            <OddsDisclaimer textAlign="left" marginTop="spacing-6" spaceX="none" />
        </NonFlexingContainer>
    )
}

export default VerticalMatchElementsCards
